export const COLORS = {
  kimberly: "#6A709A",
  cloudBurst: "#252D5F",
  havelockBlue: "#517BD3",
  heliotrope: "#C285F5",
  brightSun: "#FFCC43",
  mountainMeadow: "#1CC975",
  fiord: "#4A596E",
  walkawaGray: "#575C89",
  turquoise: "#47D4D7",
  cornflowerBlue: "#51a0f7",
  chambray: "#3B5998",
  timberGreen: "#1C2E36",
  silverChalice: "#A3A3A3",
  lightAqua: "#A3EAEB",
  flamingo: "#F05440",
  radicalRed: "#F9255D",
  melon: "#FFBCB3",
  dodgerBlue: "#5192FF",
  rajah: "#F7AA63",
  mauve: "#D5A9FB",
  persianPink: "#F578C2",
  malibu: "#79BBF7",
  porcelain: "#EEF2F3",
  amaranth: "#F03D4C",
  cupid: "#FCC9D5",
  wildSand: "#F6F6F6",
  cadetBlue: "#B6BCC6",
  parisDaisy: "#FDF16F",
  gossip: "#CBF5A0",
  salmon: "#FF7979",
  casablanca: "#FBB94B",
  portGore: "#1C204C",
  dustyGray: "#9A9A9A",
  alto: "#D5D5D5",
  victoria: "#434E93",
  polar: "#edfbfb",
  botticelli: "#D5E5E9",
  astral: "#337AB7",
  bigStone: "#122438",
  wildWatermelon: "#FD4D7B",
  apricotPeach: "#FBD4B1",
  foam: "#D8F0FB",
  magicMint: "#9FEAC7",
  palePrim: "#FEF8B8",
  chestnutRose: "#D35151",
  springGreen: "#54EDA7",
  quillGray: "#D8D8D8",
  sail: "#B1E2F7",
  navy: "#414D97",
  aliceBlue: "#F2F9FF",
};

export default {
  primary: {
    main: COLORS.havelockBlue,
    light: COLORS.havelockBlue,
    gradient: `linear-gradient(135deg,${COLORS.turquoise},${COLORS.dodgerBlue})`,
  },
  secondary: {
    main: COLORS.turquoise,
    light: COLORS.lightAqua,
    gradient: `linear-gradient(90deg,${COLORS.havelockBlue},${COLORS.malibu})`,
  },
  baseGradient: `linear-gradient(134deg,${COLORS.turquoise},${COLORS.dodgerBlue})`,
  deletion: {
    main: COLORS.flamingo,
  },
  text: {
    link: COLORS.havelockBlue,
  },
  categories: {
    holidays: COLORS.heliotrope,
    celebrate: COLORS.brightSun,
    greetings: COLORS.mountainMeadow,
  },
  social: {
    facebook: COLORS.chambray,
  },
  placeholder: COLORS.porcelain,
  overlays: {
    blue: COLORS.dodgerBlue,
    orange: COLORS.rajah,
    violin: COLORS.mauve,
    pink: COLORS.persianPink,
    green: COLORS.turquoise,
  },
  relatives: {
    me: {
      background: COLORS.lightAqua,
      CTAbackground: "linear-gradient(180deg,#A3EAEB,#47D4D7)",
      profileBackground: "linear-gradient(180deg,#79bbf7 0,#b0fcf6 100%)",
    },
    mother: {
      background: COLORS.cupid,
      CTAbackground: "linear-gradient(180deg,#FCC9D5,#F578C2)",
      profileBackground: "linear-gradient(180deg,#f578c2 0,#fbc2e4 100%)",
    },
    father: {
      background: COLORS.apricotPeach,
      CTAbackground: "linear-gradient(180deg,#FFC76C,#FBA55D)",
      profileBackground: "linear-gradient(180deg,#f99535 0,#f7b06b 100%)",
    },
    partner: {
      background: COLORS.parisDaisy,
      CTAbackground: "linear-gradient(180deg,#F9EC7D,#F5D43B)",
      profileBackground: "linear-gradient(180deg,#fad145 0,#fdf16f 100%)",
    },
    friend: {
      color: COLORS.chambray,
      background: COLORS.foam,
      CTAbackground: "linear-gradient(180deg,#FABA61,#FF599B)",
      profileBackground: "linear-gradient(180deg,#47d4d7 0,#fff46b 100%)",
    },
    family: {
      color: COLORS.chambray,
      background: COLORS.foam,
      CTAbackground: "linear-gradient(180deg,#FABA61,#FF599B)",
      profileBackground: "linear-gradient(180deg,#47d4d7 0,#fff46b 100%)",
    },
    default: {
      color: COLORS.chambray,
      background: COLORS.foam,
      CTAbackground: "linear-gradient(180deg,#A3EAEB,#47D4D7)",
      profileBackground: "linear-gradient(180deg,#47d4d7 0,#fff46b 100%)",
    },
  },
  player: {
    background: COLORS.cadetBlue,
    primary: COLORS.chambray,
    secondary: COLORS.havelockBlue,
    bright: COLORS.turquoise,
  },
  searchTerms: {
    yellow: COLORS.parisDaisy,
    blue: COLORS.lightAqua,
    green: COLORS.gossip,
    pink: COLORS.persianPink,
    red: COLORS.salmon,
    violin: COLORS.mauve,
    orange: COLORS.casablanca,
  },
  backdrop: "rgba(121,187,247,.8)",
  makeBackgrounds: {
    default: "linear-gradient(0deg, #B0DFFC 0%, #79BBF7 100%)",
    christmas: "linear-gradient(0deg, #7DECED 0%, #47D4D7 100%)",
    valentines: "linear-gradient(0deg, #FBC2E4 0%, #F578C2 100%)",
    musicvideos: "linear-gradient(0deg, #FF599B 0%, #FABA61 100%)",
    halloween: "linear-gradient(0deg, #D1A5F7 0%, #957FFF 100%)",
    dance: "linear-gradient(0deg, #F9EC7D 0%, #F5D43B 100%)",
    thanksgiving: "linear-gradient(0deg, #FAD145 0%, #FBA55D 100%)",
    newyear: "linear-gradient(0deg, #D47BD2 0%, #77AFFD 100%)",
    love: "linear-gradient(0deg, #FBC2E4 0%, #F578C2 100%)",
    weddings: "linear-gradient(0deg, #FBC2E4 0%, #F578C2 100%)",
    anniversary: "linear-gradient(0deg, #FBC2E4 0%, #F578C2 100%)",
  },
  datepickers: {
    birthday: COLORS.magicMint,
    anniversary: COLORS.palePrim,
    checkedMark: COLORS.springGreen,
    uncheckedMark: COLORS.quillGray,
  },
  ...COLORS,
};
